import type { IconSvgObject } from './types';

const LitecoinIcon: IconSvgObject = [
  ["path", { d: "M12 2C6.47716 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.5 6.5L10.1573 11.2953M10.1573 11.2953L9.29733 14.3667C9.02356 15.3444 8.88667 15.8333 9.12667 16.1667C9.36667 16.5 9.85556 16.5 10.8333 16.5H15.5M10.1573 11.2953L7.5 12.3333M10.1573 11.2953L13.9 9.83333", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default LitecoinIcon;
